import React from "react";
import Typography from "@material-ui/core/Typography";

import "./ImpLinks.css";

function ImpLinks() {
  return (
    <div>
      <div className="imp-div">
        <Typography
          variant="h6"
          color="textPrimary"
          style={{ marginBottom: "20px" }}
        >
          Important Links
        </Typography>
        <div className="imp-link">
          <div className="links">
            <Typography variant="p" color="textPrimary" className="imp-heading">
              CODING COURSES FOR BEGINNERS:
            </Typography>
            <a href="https://www.codingninjas.com/v2/courses/c-plus-plus-data-structures-and-algorithms">
              Data Structures and Alogorithms |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/aptitude-preparation">
              Aptitude Preparation
            </a>
          </div>
        </div>
        <div className="imp-link">
          <div className="links">
            <Typography variant="p" color="textPrimary" className="imp-heading">
              ADVANCED CODING COURSE:
            </Typography>
            <a href="https://www.codingninjas.com/v2/courses/web-dev-react">
              Advanced Front End Web Development with React |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/full-stack-web-dev-node-js">
              Full Stack Web Development with Node.js |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/full-stack-web-dev-mern">
              Full Stack Web Development - MERN Stack |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/android-app-development">
              Android App Development with Kotlin |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/data-science">
              Data Science |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/machine-learning">
              Machine Learning |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/interview-preparation">
              Interview Preparation |
            </a>
            <a href="https://www.codingninjas.com/v2/courses/competitive-programming">
              Competitive Programming{" "}
            </a>
          </div>
        </div>
        <div className="imp-link">
          <div className="links">
            <Typography variant="p" color="textPrimary" className="imp-heading">
              FREE TRAILS:
            </Typography>
            <a href="https://codingninjas.com/v2/free-trial-courses/onlline-c-plus-plus-course?_ga=2.186437806.665133868.1623422627-987125433.1623422626">
              C++ Foundation with Data Structures |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-java-course?_ga=2.178412835.665133868.1623422627-987125433.1623422626">
              Java Foundation with Data Structures |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-competitive-programming-course?_ga=2.178412835.665133868.1623422627-987125433.1623422626">
              Competitive Course |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-aptitude-preparation?_ga=2.178412835.665133868.1623422627-987125433.1623422626">
              Aptitude Preparation Course |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-python-course?_ga=2.19674047.665133868.1623422627-987125433.1623422626">
              Python Foundation with Data Structures |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-android-Development-kotlin?_ga=2.19674047.665133868.1623422627-987125433.1623422626">
              Android Development with Kotlin Language |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-full-stack-node-js-web-dev-course?_ga=2.48902177.665133868.1623422627-987125433.1623422626">
              Full Stack Web Development with NodeJS |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-web-dev-with-react?_ga=2.186987823.665133868.1623422627-987125433.1623422626">
              Advanced Front-End Web Development with React |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-data-science-course?_ga=2.186987823.665133868.1623422627-987125433.1623422626">
              Data Science & Machine Learning Complete |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-interview-preparation?_ga=2.23803965.665133868.1623422627-987125433.1623422626">
              Interview Preparation Course |
            </a>
            <a href="https://codingninjas.com/v2/free-trial-courses/online-machine-learning-course?_ga=2.23803965.665133868.1623422627-987125433.1623422626">
              Machine Learning Course{" "}
            </a>
          </div>
        </div>
        <div className="imp-link">
          <div className="links">
            <Typography variant="p" color="textPrimary" className="imp-heading">
              FREE CONTENTS:
            </Typography>
            <a href="https://www.codingninjas.com/v2/free-content/c-foundation-with-data-structures">
              C++ Foundation with Data Structures |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/java-foundation-with-data-structures">
              Java Foundation with Data Structures |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/competitive-programming-course">
              Competitive Programming Course |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/aptitude-preparation-course">
              Aptitude Preparation Course |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/python-foundation-with-data-structures">
              Python Foundation with Data Structures |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/android-development-with-kotlin">
              Android Development with Kotlin Language |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/full-stack-web-development">
              Full Stack Web Development with NodeJS |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/advanced-front-end-web-development-with-react">
              Advanced Front-End Web Development with React |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/data-science-machine-learning-complete">
              Data Science & Machine Learning Complete |
            </a>
            <a href="https://www.codingninjas.com/v2/free-content/interview-preparation-course">
              Interview Preparation Course{" "}
            </a>
          </div>
        </div>
        <div className="payments-div">
          <div className="payments-section">
            <h6>We accept Payments using :</h6>
            <img alt="Visa" src="https://files.codingninjas.in/visa-5604.png" />
            <img
              alt="Paypal"
              src="https://files.codingninjas.in/paypal-5603.png"
            />
            <img alt="UPI" src="https://files.codingninjas.in/upi-5602.png" />
            <img
              alt="No Cost EMI"
              src="https://files.codingninjas.in/no-cost-emi-5601.png"
            />
          </div>
          <div className="payments-section">
            <img
              src="https://files.codingninjas.in/secure-5600.png"
              alt="payment-img"
            />
            <img
              src="https://files.codingninjas.in/encryp-5599.png"
              alt="secure-img"
            />
            <img
              src="https://files.codingninjas.in/razorpay-5598.png"
              alt="razorpay-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImpLinks;
